import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function NovedadesEnvioExtraviado() {
  return (
    <ClipperPlaceholder title="Envío Extraviado" category="Novedades" />
  );
}
